<template>
  <div class="form-group">
    <label v-if="label" :for="name">{{ label }}</label>
    <input
      :id="name"
      :required="required"
      :type="type"
      :placeholder="placeholder"
      :name="name"
      class="form-control"
    />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
